// extracted by mini-css-extract-plugin
module.exports = {"summary_item":"_924b119625--summary_item--KB16Y","dashed_line":"_924b119625--dashed_line--id3mR"};